import { Locale } from "@/i18n/i18n.config";
import { cn } from "@/libs/base/utils/layout";
import { useEffect, useState } from "react";

interface ComponentProps {
  locale: Locale;
  selectableLocales: Locale[];
  selectLocale: (locale: Locale) => void;
}

export default function LocaleSwitcher({ locale, selectableLocales, selectLocale }: ComponentProps) {
  const [currentLocale, setCurrentLocale] = useState<Locale>(locale);

  useEffect(() => {
    const timer = setTimeout(() => {
      selectLocale(currentLocale);
    }, 250);

    return () => clearTimeout(timer);
  }, [currentLocale]);

  if (locale !== "en" && locale !== "de") {
    console.error("Unsupported Locale", locale);
    return <>Unsupported Locale {locale}</>;
  }
  if (selectableLocales.indexOf("en") === -1 && selectableLocales.indexOf("de") === -1) {
    console.error("Unsupported Locales", selectableLocales);
    return <>Unsupported Locales {selectableLocales.join(", ")}</>;
  }

  return (
    <div
      className="flex h-9 w-[78px] cursor-pointer select-none items-center rounded-3xl bg-lightgray-100 text-xs uppercase"
      onClick={() => setCurrentLocale(currentLocale === "en" ? "de" : "en")}
    >
      <span
        className={cn(
          "z-0 rounded-full bg-white px-[11px] py-[6px] transition-transform duration-200 ease-in-out",
          currentLocale === "de" && "translate-x-[30px]",
          currentLocale === "en" ? "mx-[5.5px]" : "mx-[6.5px]",
        )}
      >
        {currentLocale === "en" ? "EN" : "DE"}
      </span>
      <div className="absolute z-10 flex w-full gap-[19px] px-2 transition-transform duration-200 ease-in-out">
        <span className={cn("ml-[7px] text-lightgray-300 opacity-100", currentLocale === "en" && "opacity-0")}>EN</span>
        <span
          className={cn(
            "px-[-3px] text-lightgray-300 opacity-100 transition-transform duration-200 ease-in-out",
            currentLocale === "de" && "opacity-0",
          )}
        >
          DE
        </span>
      </div>
    </div>
  );
}
